import { render, staticRenderFns } from "./TarifsAccidentDeces.vue?vue&type=template&id=873c0366&scoped=true&"
import script from "./TarifsAccidentDeces.vue?vue&type=script&lang=js&"
export * from "./TarifsAccidentDeces.vue?vue&type=script&lang=js&"
import style0 from "./TarifsAccidentDeces.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsAccidentDeces.vue?vue&type=style&index=1&id=873c0366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873c0366",
  null
  
)

export default component.exports